import React from 'react';
import {useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/state';

//Component
import { DynamicTypography, GridContainer, GridItem } from '../../components';
import Typography from '@material-ui/core/Typography';
import { FiservForm } from 'components/FiservForm';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Card,
  Radio,
} from '@material-ui/core';

import '@adyen/adyen-web/dist/adyen.css';

//Helper
import { getVerbiage, convertNumberToAmount } from '../../utils/stringHelper';
import { getFiservPreAuthInfo } from 'reducers/payment';
interface IProps {
  onPayOptionChecked: (isClicked: boolean) => void;
  onFiservConfigRetrieved: (isCompleted: boolean) => void;
  handleFiservPay: () => void;
}

export const FiservCheckoutPayment: React.FC<IProps> = ({
  onPayOptionChecked,
  onFiservConfigRetrieved,
  handleFiservPay
}) => {
  const dispatch = useDispatch();
  const { verbiages } = useSelector((state: RootState) => state.verbiages);
  const { selectedReservation } = useSelector((state: RootState) => state.reservationState);
  const { selectedHotel } = useSelector((state: RootState) => state.hotelState);
  const { preAuthCardInfo } = useSelector((state: RootState) => state.paymentState);

  const [isPayingWithPreAuthCardChecked, setIsPayingWithPreAuthCardChecked] = React.useState(false);
  const [isPayingWithNewCardChecked, setIsPayingWithNewCardChecked] = React.useState(false);

  const [isFiservConfigRetrieved, setIsFiservConfigRetrieved] = React.useState(false);

  const handleIsPayingWithPreAuthCardChange = () => {
    const searchReservation = async () => {
      if (selectedHotel != undefined && selectedReservation != undefined) {
        dispatch(getFiservPreAuthInfo({ request: { guid: selectedReservation.guid } }));
      }
    };

    if (isPayingWithNewCardChecked) {
      setIsPayingWithNewCardChecked(false);
    }

    if (!isPayingWithPreAuthCardChecked) {
      setIsPayingWithPreAuthCardChecked(true);
    }
    searchReservation();
    onPayOptionChecked(true);
  };

  const handleIsPayingWithNewCardChange = () => {
    if (isPayingWithPreAuthCardChecked) {
      setIsPayingWithPreAuthCardChecked(false);
    }

    if (!isPayingWithNewCardChecked) {
      setIsPayingWithNewCardChecked(true);
    }
    onPayOptionChecked(true);
  };

  React.useEffect(()=>{
    onPayOptionChecked(false);
  },[]);

  return (
    <GridContainer
      spacing={1}
      alignItems="center"
      justifyContent="center"
      direction="row"
      style={{ paddingTop: '24px', paddingLeft: '18px', paddingRight: '18px' }}
    >
      <FiservForm onRetrieveConfigCompleted={(c)=>{setIsFiservConfigRetrieved(c); onFiservConfigRetrieved(c)}} onSubmit={handleFiservPay} isPreAuthCard={isPayingWithPreAuthCardChecked}/>
        <GridItem xs={12}>
        <DynamicTypography
            color="textPrimary"
            align="center"
            variant="body2"
            content ="Outstanding Balance"
        ></DynamicTypography>
        </GridItem>

        <GridItem xs={12} style={{ marginTop: '16px', marginBottom: '16px' }}>
        <Typography color="textPrimary" align="center" variant="h4">
            <b>{`${selectedReservation?.currency} ${convertNumberToAmount(selectedReservation?.totalPrice)}`}</b>
        </Typography>
        </GridItem>

      {isFiservConfigRetrieved ? (
        <>
        {/* Select a payment method */}
        <GridItem xs={12}>
        <Typography color="textSecondary" align="left" variant="subtitle1">
            {`${getVerbiage(verbiages, 'weblbl075')}`}
        </Typography>
        </GridItem>

        <GridItem xs={12}>
        <Card>
          <GridContainer
            onClick={handleIsPayingWithPreAuthCardChange}
            alignItems="center"
            style={{ height: '66px', paddingLeft: '4px', paddingRight: '4px' }}
          >
            <Radio
              color="primary"
              checked={isPayingWithPreAuthCardChecked}
              onChange={handleIsPayingWithPreAuthCardChange}
            />
            {preAuthCardInfo !== undefined &&
              preAuthCardInfo.cardType != null &&
              preAuthCardInfo.cardNo != null 
              ?
              <DynamicTypography
                color="textPrimary"
                align="left"
                variant="body1"
                //content={`${getVerbiage(verbiages, 'weblbl076')}`}
                content={`${preAuthCardInfo.cardType.toLocaleUpperCase()} ${preAuthCardInfo.cardNo}`}
              ></DynamicTypography>
              :
                <DynamicTypography
                  color="textPrimary"
                  align="left"
                  variant="body1"
                  //content={`${getVerbiage(verbiages, 'weblbl076')}`}
                  content="Pay with preauth card">
                </DynamicTypography>
              }
          </GridContainer>
        </Card>
      </GridItem>
        <GridItem xs={12}>
          <Card>
            <GridContainer
              onClick={handleIsPayingWithNewCardChange}
              alignItems="center"
              style={{ height: '66px', paddingLeft: '4px', paddingRight: '4px' }}
            >
              <Radio
                color="primary"
                checked={isPayingWithNewCardChecked}
                onChange={handleIsPayingWithNewCardChange}
              />
              <DynamicTypography
                color="textPrimary"
                align="left"
                variant="body1"
                content={`${getVerbiage(verbiages, 'weblbl076')}`}
              ></DynamicTypography>
            </GridContainer>
          </Card>
        </GridItem>
        </>
      ):
        <GridItem>
          <CircularProgress />
        </GridItem>
      }
    </GridContainer>
  );
};
